"use client";
import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import {
    ICM_MAIL,
    priyansh_saxena_incredmoney,
    vijay_kuppa_incredmoney,
    vipin_kumar_incredmoney,
} from "@/app/utils/constants";

const MatrixTable = () => {
    return (
        <section className="mx-auto bg-neutral-50 px-6 pb-14 pt-8 md:container md:bg-transparent md:pb-[120px]">
            <h2 id="heading" className="mb-4 text-lg font-semibold md:mb-6 md:text-4xl">
                COMPLAINT REDRESSAL ESCALATION MATRIX
            </h2>
            <p id="sub-heading" className="mb-10 text-base font-semibold text-gray-500 md:text-lg">
                *We are experiencing heavy traffic on our customer care numbers. If we are unable to
                answer your call, please email us at{" "}
                <a href={"mailto:" + ICM_MAIL} className="text-blue-600 hover:underline">
                    {ICM_MAIL}
                </a>
                . We will respond within 2 working days.
            </p>

            <div className="overflow-x-auto">
                {/* Wrapper div with border radius */}
                <div className="overflow-hidden rounded-[16px] border border-gray-200">
                    <Table id="matrix-table" className="w-full border-separate border-spacing-0">
                        <TableHeader>
                            <TableRow
                                id="matrix-row1"
                                className="bg-[#E0E9EA] text-md text-gray-500"
                            >
                                <TableHead className="w-[136px] px-0 py-2 pl-4 text-left font-semibold">
                                    Escalation Level
                                </TableHead>
                                <TableHead className="px-0 py-2 pl-4 text-left font-semibold">
                                    Details of
                                </TableHead>
                                <TableHead className="px-0 py-2 pl-4 text-left font-semibold">
                                    Contact Person
                                </TableHead>
                                <TableHead className="px-0 py-2 pl-4 text-left font-semibold">
                                    Address
                                </TableHead>
                                <TableHead className="px-0 py-2 pl-4 text-left font-semibold">
                                    Contact No
                                </TableHead>
                                <TableHead className="px-0 py-2 pl-4 text-left font-semibold">
                                    Email id
                                </TableHead>
                                <TableHead className="px-0 py-2 pl-4 text-left font-semibold">
                                    Working Hours
                                </TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            <TableRow id="matrix-row2" className="border-b text-gray-500">
                                <TableCell className="px-4 py-3 align-top">Level 1</TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Customer Experience
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Customer Experience Team
                                </TableCell>
                                <TableCell className="min-w-48 px-4 py-3 align-top md:min-w-0">
                                    Unit 1201-1205, B Wing, 12th Floor, Kanakia Wallstreet, Andheri
                                    East, Mumbai - 400059
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    {/* <a
                                        href="tel:8928250817"
                                        className="text-blue-600 hover:underline"
                                    >
                                        8928250817
                                    </a>
                                    <br />
                                    <a
                                        href="tel:8591871028"
                                        className="text-blue-600 hover:underline"
                                    >
                                        8591871028
                                    </a>
                                    <br /> */}
                                    <a
                                        href="tel:7738351453"
                                        className="text-blue-600 hover:underline"
                                    >
                                        7738351453
                                    </a>
                                    <br />
                                    <a
                                        href="tel:7738352573"
                                        className="text-blue-600 hover:underline"
                                    >
                                        7738352573
                                    </a>
                                    <br />
                                    <a
                                        href="tel:8828538217"
                                        className="text-blue-600 hover:underline"
                                    >
                                        8828538217
                                    </a>
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    <a
                                        href={"mailto:" + ICM_MAIL}
                                        className="text-blue-600 hover:underline"
                                    >
                                        {ICM_MAIL}
                                    </a>
                                </TableCell>
                                <TableCell className="min-w-36 px-4 py-3 align-top md:min-w-0">
                                Monday to Friday: 8:00 am to 8:00 pm. <br />
                                Saturday and Sunday: 9:30 am to 7:00 pm (excluding public holidays)
                                </TableCell>
                            </TableRow>

                            <TableRow id="matrix-row3" className="border-b text-gray-500">
                                <TableCell className="px-4 py-3 align-top">Level 2</TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Head of Customer Experience
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Priyansh Saxena
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Unit 1201-1205, B Wing, 12th Floor, Kanakia Wallstreet, Andheri
                                    East, Mumbai - 400059
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    <a
                                        href="tel:9137118088"
                                        className="text-blue-600 hover:underline"
                                    >
                                        9137118088
                                    </a>
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    <a
                                        href={`mailto:${priyansh_saxena_incredmoney}`}
                                        className="text-blue-600 hover:underline"
                                    >
                                        {priyansh_saxena_incredmoney}
                                    </a>
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                Monday to Friday: 8:00 am to 8:00 pm. <br />
                                Saturday and Sunday: 9:30 am to 7:00 pm (excluding public holidays)
                                </TableCell>
                            </TableRow>

                            <TableRow id="matrix-row3" className="border-b text-gray-500">
                                <TableCell className="px-4 py-3 align-top">Level 2</TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Head Operations
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">Vipin Kumar</TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Unit 1201-1205, B Wing, 12th Floor, Kanakia Wallstreet, Andheri
                                    East, Mumbai - 400059
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    <a
                                        href="tel:9619224646"
                                        className="text-blue-600 hover:underline"
                                    >
                                        9619224646
                                    </a>
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    <a
                                        href={`mailto:${vipin_kumar_incredmoney}`}
                                        className="text-blue-600 hover:underline"
                                    >
                                        {vipin_kumar_incredmoney}
                                    </a>
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                Monday to Friday: 8:00 am to 8:00 pm. <br />
                                Saturday and Sunday: 9:30 am to 7:00 pm (excluding public holidays)
                                </TableCell>
                            </TableRow>

                            <TableRow id="matrix-row3" className="text-gray-500">
                                <TableCell className="px-4 py-3 align-top">Level 3</TableCell>
                                <TableCell className="px-4 py-3 align-top">Business Head</TableCell>
                                <TableCell className="px-4 py-3 align-top">Vijay Kuppa</TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    Unit 1201-1205, B Wing, 12th Floor, Kanakia Wallstreet, Andheri
                                    East, Mumbai - 400059
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    <a
                                        href="tel:9819492358"
                                        className="text-blue-600 hover:underline"
                                    >
                                        9819492358
                                    </a>
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                    <a
                                        href={`mailto:${vijay_kuppa_incredmoney}`}
                                        className="text-blue-600 hover:underline"
                                    >
                                        {vijay_kuppa_incredmoney}
                                    </a>
                                </TableCell>
                                <TableCell className="px-4 py-3 align-top">
                                Monday to Friday: 8:00 am to 8:00 pm. <br />
                                Saturday and Sunday: 9:30 am to 7:00 pm (excluding public holidays)
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
            </div>
        </section>
    );
};

export default MatrixTable;
